<template>
  <a-layout-content>
    <div class="body-nest">
      <a-table bordered row-key="ID" size="middle" :columns="columns" :data-source="datarow" :pagination="false">
        <template slot="title">
          <a-row>
            <a-col :span="6" style="line-height: 30px">{{
              this.input.name
              }}</a-col>
            <a-col style="float: right">
              <a href="javascript:;" @click="add()">
                <a-button type="primary"><a-icon type="plus"></a-icon>新增</a-button>
              </a>
              <router-link :to="'/customerservicelist'">
                <a-button type="primary"><a-icon type="rollback"></a-icon>返回</a-button>
              </router-link>
            </a-col>
          </a-row>
        </template>
        <template slot="Type" slot-scope="text, record">
          <a-tag v-if="record.Type == '1'" color="cyan">字串</a-tag>
          <a-tag v-else-if="record.Type == '2'" color="cyan">数字</a-tag>
          <a-tag v-else-if="record.Type == '3'" color="cyan">手机格式</a-tag>
          <a-tag v-else-if="record.Type == '4'" color="cyan">时间格式</a-tag>
          <a-tag v-else-if="record.Type == '5'" color="cyan">上传文件</a-tag>
        </template>
        <template slot="Isneed" slot-scope="text, record">
          <a-tag v-if="record.Isneed == '1'" color="cyan">是</a-tag>
          <a-tag v-else-if="record.Isneed == '0'" color="red">否</a-tag>
        </template>
        <template slot="Operation" slot-scope="text, record">
          <a-tooltip title="编辑">
            <a href="javascript:;" @click="edit(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;&nbsp;
          <a-tooltip title="删除">
            <a @click="deletefield(record)">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="字段编辑" @ok="Save">
      <a-form-model :model="form" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="字段名称" prop="Name" ref="Name">
          <a-input v-model="form.Name" type="text" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item label="类型">
          <a-select v-model="form.Type">
            <a-select-option value="1">字串</a-select-option>
            <a-select-option value="2">数字</a-select-option>
            <a-select-option value="3">手机格式</a-select-option>
            <a-select-option value="4">时间格式</a-select-option>
            <a-select-option value="5">上传文件</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="必填">
          <a-switch checked-children="是" un-checked-children="否" :checked="form.Isneed == 1"
            @change="swichstate($event,'form.Isneed')" />
        </a-form-model-item>
        <a-form-model-item label="排序" prop="Sort" ref="Sort">
          <a-input-number v-model="form.Sort" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
  import lodash from 'lodash';
  import { isNumber } from "../../js/textverify";

  export default {
    data() {
      return {
        //------table --------
        columns: IninTable(),
        datarow: [],
        //--------------------
        input: { id: 0, name: "" },
        visible: false, //弹框状态
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        action: "add",
        form: {},
        rules: {
          Name: [
            { required: true, message: '请输入字段名称', trigger: 'blur' },
          ],
          Sort: [
            { required: true, message: '请输入排序', trigger: 'blur' },
            { validator: isNumber, trigger: 'change' },
          ],
        },
      };
    },
    methods: {
      query() {
        let param = {
          ID: this.input.id
        };
        this.axios
          .post("/customerservice/customerserviceinputqry", param)
          .then((res) => {
            this.datarow = res.data;
          });
      },
      //新增
      add() {
        this.action = "add";
        this.visible = true;
        this.form = { ID: this.input.id, Name: "", Type: "1", Isneed: 0, Sort: 1 }
      },
      //编辑
      edit(record) {
        this.action = "edit";
        this.visible = true;
        this.form = lodash.cloneDeep(record);
      },
      Save() {
        var _this = this;
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            let urlType = _this.action === "add" ? "customerserviceinputadd" : "customerserviceinputedit";
            _this.axios.post("/customerservice/" + urlType, _this.form).then((res) => {
              if (res.data == "0") {
                _this.$message.success("操作成功");
              }
              _this.query();
              _this.visible = false;
            });
          }
        });
      },
      //删除
      deletefield(record) {
        let _this = this;
        const IDList = [];
        IDList.push({ ID: record.ID });
        this.$confirm({
          title: "删除",
          content: "您要确定要删除吗?",
          onOk() {
            _this.axios.post("/customerservice/customerserviceinputdelete", { IDList: IDList }).then((res) => {
              if (res.data) {
                _this.$message.success("删除成功");
                _this.query();
              }
            });
          },
        });
      },
      swichstate(val, flag) {
        if (flag == "form.Isneed") {
          this.form.Isneed = val ? 1 : 0;
        }
      },
    },
    created() {
      this.input.id = this.$route.params.id;
      this.input.name = this.$route.params.Name;
      this.query();
    },
    watch: {
      $route(to, from) {
        if (to.name === "customerserviceinput") {
          this.input.id = this.$route.params.id;
          this.input.name = this.$route.params.Name;
          this.query();
        }
      },
    },
  };

  const IninTable = function IninTable() {
    var header = [];
    header.push({
      title: "字段名称",
      align: "center",
      dataIndex: "Name",
    });
    header.push({
      title: "字段类型",
      align: "center",
      dataIndex: "Type",
      scopedSlots: { customRender: "Type" },
    });
    header.push({
      title: "排序",
      align: "center",
      width: 120,
      sorter: (a, b) => a.Sort - b.Sort,
      dataIndex: "Sort",
    });
    header.push({
      title: "必填",
      align: "center",
      dataIndex: "Isneed",
      width: 120,
      scopedSlots: { customRender: "Isneed" },
    });
    header.push({
      title: "操作",
      align: "center",
      width: 300,
      scopedSlots: { customRender: "Operation" },
    });
    return header;
  };
</script>

<style>
  .clearline {
    border-top: solid #acc0d8 1px;
    margin: 10px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/customerservice/customerserviceinput.vue